import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class AbstractService<T> {

  constructor() { }

  add(data: T): Promise<any> {
    return;
  }

  update(data: T): Promise<any> {
    return;
  }
}
